module.exports = __webpack_public_path__ + "img/Rocket.804369a9.svg";